module.exports = __webpack_public_path__ + "2021109/img/avatar.f57ebce8.png";